import React from 'react';
import { useLocalization } from '../../../hooks/useLocalization';
import { RTLMainContent, RTLContentSection, RTLCardContainer } from '../../../styles/RTLStyledComponents';

interface RTLWrapperProps {
  children: React.ReactNode;
  layout?: 'main' | 'sidebar' | 'full';
  className?: string;
  style?: React.CSSProperties;
}

export const RTLWrapper: React.FC<RTLWrapperProps> = ({ 
  children, 
  layout = 'full',
  className = '',
  style = {}
}) => {
  const { isRTL, getRTLLayout } = useLocalization();
  const rtlClasses = getRTLLayout();

  const combinedClassName = `${className} ${layout === 'full' ? rtlClasses.textAlign : ''}`;

  return (
    <RTLMainContent isRTL={isRTL} className={combinedClassName} style={style}>
      {children}
    </RTLMainContent>
  );
};

interface RTLContentProps {
  children: React.ReactNode;
  layout?: 'main' | 'sidebar' | 'full';
  className?: string;
}

export const RTLContent: React.FC<RTLContentProps> = ({ 
  children, 
  layout = 'full',
  className = ''
}) => {
  const { isRTL } = useLocalization();

  return (
    <RTLContentSection isRTL={isRTL} layout={layout} className={className}>
      {children}
    </RTLContentSection>
  );
};

interface RTLCardWrapperProps {
  children: React.ReactNode;
  className?: string;
}

export const RTLCardWrapper: React.FC<RTLCardWrapperProps> = ({ 
  children, 
  className = ''
}) => {
  const { isRTL } = useLocalization();

  return (
    <RTLCardContainer isRTL={isRTL} className={className}>
      <div className="card-content">
        {children}
      </div>
    </RTLCardContainer>
  );
};

interface RTLLayoutProps {
  mainContent: React.ReactNode;
  sideContent?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const RTLLayout: React.FC<RTLLayoutProps> = ({ 
  mainContent, 
  sideContent,
  className = '',
  style = {}
}) => {
  const { isRTL, getRTLLayout } = useLocalization();
  const rtlClasses = getRTLLayout();

  return (
    <RTLWrapper className={className} style={style}>
      <div className={`content-wrapper ${rtlClasses.flexRow}`}>
        <RTLContent layout="main" className="main-section">
          <RTLCardWrapper>
            {mainContent}
          </RTLCardWrapper>
        </RTLContent>
        
        {sideContent && (
          <RTLContent layout="sidebar" className="side-section">
            <RTLCardWrapper>
              {sideContent}
            </RTLCardWrapper>
          </RTLContent>
        )}
      </div>
    </RTLWrapper>
  );
};

export default RTLWrapper; 